import { render } from "./OffcanvasInfo.vue?vue&type=template&id=92013634&scoped=true"
import script from "./OffcanvasInfo.vue?vue&type=script&lang=js"
export * from "./OffcanvasInfo.vue?vue&type=script&lang=js"

import "./OffcanvasInfo.vue?vue&type=style&index=0&id=92013634&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92013634"]])

export default __exports__